import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";
import "./CategoryPage.css";

const BASE = "https://storage.googleapis.com/rasai-nutrie-assets/products/biscuits";

const biscuits = [
  { id: "biscuit-peanut",  name: "Peanut Biscuits",  price: 140, serving: "15 pcs", image: `${BASE}/peanut.png` },
  { id: "biscuit-tomato",  name: "Tomato Biscuits",  price: 151, serving: "15 pcs", image: `${BASE}/tomato.png` },
  { id: "biscuit-protein", name: "Protein Biscuits", price: 157, serving: "15 pcs", image: `${BASE}/protein.png` },
];

const BiscuitsPage = () => (
  <div className="category-page">
    <div className="category-hero" style={{ backgroundImage: `url(${BASE}/banner.jpg)` }}>
      <div className="category-hero-overlay">
        <Link to="/products" className="category-back">← All Categories</Link>
        <h1 className="category-hero-title">BISCUITS</h1>
        <p className="category-hero-sub">Natural ingredients · Wholesome snacking · RASAI nutrie</p>
      </div>
    </div>
    <div className="category-body" style={{ backgroundImage: `url(${BASE}/background.jpg)` }}>
      <div className="category-grid category-grid--3">
        {biscuits.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default BiscuitsPage;
